import { Text } from "~/components/Text";

type SectionHeadingProps = {
  children: React.ReactNode;
  dark?: boolean;
  as?: "h2" | "h3";
  size?: "xs" | "sm" | "md";
  className?: string;
};

const SIZE_OVERRIDES: Record<NonNullable<SectionHeadingProps["size"]>, string> = {
  xs: "",
  sm: "",
  md: "!text-[22px] !leading-[28px]",
};

export function SectionHeading({
  children,
  dark = false,
  as = "h2",
  size = "md",
  className = "",
}: SectionHeadingProps) {
  return (
    <Text
      variant="primary"
      size={size}
      as={as}
      color={dark ? "light" : "green"}
      className={`${SIZE_OVERRIDES[size]} ${className}`}
    >
      {children}
    </Text>
  );
}
